import React from 'react';
import { useHistory, generatePath, useLocation } from 'react-router-dom';
import { PATHS } from '@/config/router/routes';
import OfferDetailsForm from '@/components-latest/ui/OfferPage/OfferDetailsForm';

const OfferDetailsFormWrapper: React.FC = () => {
  const history = useHistory()
  const location = useLocation()
  const state = location.state as {
    isEditing?: boolean
    offerId?: string
    initialDiscount?: number
    initialExpiration?: string
    name?: string
    
  }


  const handleSuccess = () => {
    history.replace(generatePath(PATHS.OFFERS_BY_ID, { id: 'item_discount' }));
  };

  return (<OfferDetailsForm onSuccess={handleSuccess}
      offerId={state?.offerId}
      initialDiscount={state?.initialDiscount}
      initialExpiration={state?.initialExpiration}
      name={state?.name}
      
    />
  )
}
export default OfferDetailsFormWrapper;
